<div class="container">
  <div class="close" (click)="closeDialog()">
    <img src="assets/icons/news/close.svg" alt="close modal" />
  </div>
  <h1 class="title">{{ data.title }}</h1>
  <form [formGroup]="formGroup" class="form" (keyup.enter)="addInformation()">
    <mat-form-field appearance="outline">
      <mat-label>Nombre cuenta</mat-label>
      <input matInput type="text" name="name" formControlName="name" />
      <mat-error
        for="name"
        class="form-error"
        *ngIf="
          (!formGroup.controls.name.pristine || formGroup.controls.name.touched) &&
          formGroup.controls.name.invalid
        "
      >
        {{ getErrorMessage('name') }}
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Dirección</mat-label>
      <input matInput name="address" formControlName="address" />
      <mat-error
        for="address"
        *ngIf="
          (!formGroup.controls.address.pristine || formGroup.controls.address.touched) &&
          formGroup.controls.address.invalid
        "
      >
        {{ getErrorMessage('address') }}
      </mat-error>
    </mat-form-field>
    <mat-form-field class="networks-list" appearance="outline">
      <mat-select
        formControlName="network"
        [style.background]="
          'url(/assets/icons/news/' + imageCryptoCard[formGroup.controls.network.value] + '.svg)'
        "
      >
        <mat-option *ngFor="let network of shownNetworks" [value]="network.code">
          <img
            class="option-img"
            [src]="'/assets/icons/news/' + imageCryptoCard[network.code] + '.svg'"
            width="24"
            alt="networkIcon"
          />
          <span class="option-description"> {{ getNetworkFullName(network.code) }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button class="td-btn primary" (click)="addInformation()">Agregar</button>
  </form>
</div>
